import { render, staticRenderFns } from "./CreatePositionPostForm.vue?vue&type=template&id=4e6a69d0&scoped=true"
import script from "./CreatePositionPostForm.vue?vue&type=script&lang=js"
export * from "./CreatePositionPostForm.vue?vue&type=script&lang=js"
import style0 from "./CreatePositionPostForm.vue?vue&type=style&index=0&id=4e6a69d0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e6a69d0",
  null
  
)

export default component.exports